module.exports = __webpack_public_path__ + "img/terroir-charcoal-3-mobile.eede8ed4.jpg";